module.exports = __webpack_public_path__ + "8bd0cbf758df085dc782a82a4ed9310a.svg";